/* eslint-disable @typescript-eslint/no-explicit-any */
export const wait = (time: number) => {
  let timer: NodeJS.Timeout;

  return new Promise((resolve) => {
    clearTimeout(timer);
    timer = setTimeout(resolve, time);
  });
};

export const debounce = (func: () => void, timeout = 300) => {
  let timer: NodeJS.Timeout;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (...args: any) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
};
